import {Page} from "./Page";

export default class ChipPreamblePage extends Page {
    getNavTitle(): string {
        return 'Chip Evaluation';
    }
}
